import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RoutingModule} from './app-router.module';
import {AuthService} from './auth.service';
import {AuthGuardService} from './auth-guard.service';
import {ApiService} from './api.service';
import {AppComponent} from './app.component';
import {MissingComponent} from './missing/missing.component';
import {HomeComponent} from './home/home.component';
import {ProfileComponent} from './profile/profile.component';
import {SearchComponent} from './search/search.component';
import {UploadComponent} from './upload/upload.component';
import {MaterialModule} from './material/material.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FileSelectDirective} from 'ng2-file-upload';
import {ImagePreviewDirective} from './image-preview.directive';
import {PostcardComponent} from './postcard/postcard.component';
import {MatButtonModule, MatDialogModule, MatTooltipModule} from '@angular/material';
import {ReportIssueComponent} from './report-issue/report-issue.component';
import {HttpClientModule} from '@angular/common/http';
import { ChangeUserComponent } from './change-user/change-user.component';
import { AboutComponent } from './about/about.component';
import { NgxTwitterTimelineModule } from 'ngx-twitter-timeline';

@NgModule({
  declarations: [
    AppComponent,
    MissingComponent,
    HomeComponent,
    ProfileComponent,
    SearchComponent,
    UploadComponent,
    FileSelectDirective,
    ImagePreviewDirective,
    PostcardComponent,
    ReportIssueComponent,
    ChangeUserComponent,
    AboutComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    RoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    MatTooltipModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgxTwitterTimelineModule
  ],
  providers: [
    AuthService,
    AuthGuardService,
    ApiService
  ],
  entryComponents: [
    ReportIssueComponent,
    ChangeUserComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
